import React from 'react'
import PersonOutlined from '@material-ui/icons/PersonOutlined'

export default function PersonOutlinedIcon({ ...other }) {

    return (
        <PersonOutlined {...other} />
    )
}